const LOGO_URL =
  "https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/050a4db70d65b968b005ddd7348aeef2.png";
const WHATSAPP_LINK = "https://wa.me/557183822916";

const footerLinks = [
  { label: "Início", href: "#inicio" },
  { label: "O Escritório", href: "#escritorio" },
  { label: "Áreas de Atuação", href: "#atuacao" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Contato", href: "#contato" },
];

const socials = [
  { icon: "ri-whatsapp-line", href: WHATSAPP_LINK, label: "WhatsApp" },
];

export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-petrol-darkest border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <img
              src={LOGO_URL}
              alt="Georges Humbert Advocacia"
              className="h-16 w-auto object-contain mb-5"
            />
            <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-xs">
              Advocacia estratégica com ética, excelência técnica e compromisso
              com os resultados de cada cliente.
            </p>
            {/* Socials */}
            <div className="flex items-center gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-md border border-white/15 text-white/50 hover:text-gold-light hover:border-gold-light/30 transition-all duration-300 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-semibold text-sm tracking-wide mb-5">
              Navegação
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                    className="text-white/50 hover:text-gold-light text-sm transition-colors duration-300 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm tracking-wide mb-5">
              Contato
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-gold-light text-sm" />
                </span>
                <p className="text-white/50 text-sm leading-relaxed">
                  Rua Sen. Theotônio Vilela, 225, Sala 606<br />
                  Ed. Centro Cidadela III<br />
                  Parque Bela Vista — Salvador/BA<br />
                  CEP 40279-435
                </p>
              </div>
              <a
                href="tel:+557183822916"
                className="flex items-center gap-3 text-white/50 hover:text-gold-light text-sm transition-colors cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-gold-light text-sm" />
                </span>
                (71) 98382-2910
              </a>
              <a
                href="mailto:georges@humbert.com.br"
                className="flex items-center gap-3 text-white/50 hover:text-gold-light text-sm transition-colors cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-gold-light text-sm" />
                </span>
                georges@humbert.com.br
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-white/30 text-xs">
          <p>
            © 2026 Georges Humbert Sociedade Individual de Advocacia. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-5">
            <a
              href="https://startdigital1.com.br"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="hover:text-gold-light/60 transition-colors cursor-pointer"
            >
              Desenvolvido por Start Digital
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
